import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        banner: {
            backgroundColor: 'background.neutral.dark',
            maxWidth: {
                base: '100%',
                sm: '100%',
                md: '90%',
                lg: '90%',
            },
            borderTop: 'small',
            borderTopRadius: 'large-1',
            pos: 'fixed',
            bottom: '0',
            left: 0,
            right: 0,
            marginX: 'auto',
            w: '100%',
            zIndex: '888',
            minH: remCalc(60),
            backdropFilter: 'blur(calc(var(--sm, 8px) / 2))',
        },
        bannerHeader: {
            justify: 'space-between',
            width: '100%',
            align: 'center',
            gap: remCalc(8),
            cursor: 'pointer',
        },
        bannerHeaderLabel: {
            textAlign: 'center',
            fontWeight: 'medium',
            textStyle: 'body-small',
            color: 'foreground.neutral.inverse',
        },
        productSelectionContainer: {
            backgroundColor: 'background.neutral.hover',
            h: {base: remCalc(46), lg: remCalc(64)},
            align: 'center',
            width: '100%',
            gap: {
                base: remCalc(8),
                lg: remCalc(12),
            },
            padding: {
                base: `${remCalc(6)} ${remCalc(8)} ${remCalc(6)} ${remCalc(6)}`,
                sm: `${remCalc(6)} ${remCalc(8)} ${remCalc(6)} ${remCalc(6)}`,
                md: `${remCalc(8)} ${remCalc(12)} ${remCalc(8)} ${remCalc(8)}`,
                lg: `${remCalc(8)} ${remCalc(12)} ${remCalc(8)} ${remCalc(8)}`,
            },
            justify: 'space-between',
            position: 'relative',
            borderRadius: 'large-1',
        },
        productSelectionSubContainer: {
            gap: {base: remCalc(24), lg: remCalc(9)},
            align: 'center',
        },
        productSelectionImage: {w: {base: remCalc(40), lg: remCalc(48)}, ratio: 1},
        productSelectionName: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'regular',
        },
        productSelectionClose: {
            position: {base: 'block', lg: 'absolute'},
            top: '33%',
            right: remCalc(10),
            boxSize: 'iconsSize.small',
            minWidth: 'auto',
            height: 'auto',
            padding: 0,
        },
        productSelectionEmptyContainer: {
            h: {base: remCalc(46), lg: remCalc(64)},
            width: '100%',
            backgroundColor: 'transparent',
            border: 'small',
            borderColor: 'background.neutral.white',
            borderStyle: 'dashed',
            borderRadius: 'large-1',
            justify: 'center',
            align: 'center',
            color: 'foreground.neutral.dim',
            gap: {
                base: 'xxxsmall-1.base',
                sm: 'xxxsmall-1.base',
                md: 'xsmall.base',
                lg: 'xsmall.base',
            },
        },
        productSelectionText: {
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        modal: {
            width: '100%',
            height: '100%',
            background: 'background.base.default',
        },
        modalBody: {
            gap: {base: remCalc(13), lg: remCalc(40)},
            layerStyle: 'page',
        },
        modalStickySelectSection: {
            width: '100%',
            background: 'background.base.default',
        },
        modalStickySelectBarFixed: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            width: '100%',
            zIndex: 2,
            background: 'background.base.default',
            boxShadow: '0 2px 8px 0 var(--chakra-shadows-neutral-sm)',
            borderBottom: 'small',
            borderBottomStyle: 'solid',
            borderColor: 'border.neutral.default',
            paddingY: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        },
        modalSelectBarFixedInset: {
            layerStyle: 'page',
        },
        modalStickySelectGrid: {
            width: '100%',
            gap: {base: remCalc(12), md: remCalc(40)},
            alignItems: 'stretch',
        },
        modalCloseIcon: {
            boxSize: {base: 'iconsSize.medium'},
        },
        modalProductTilesGrid: {
            w: '100%',
            maxW: {base: remCalc(360), md: remCalc(1280), lg: remCalc(1760)},
            mx: 'auto',
            alignItems: 'stretch',
            gap: {base: remCalc(12), md: remCalc(40)},
        },
        tileImage: {
            w: '100%',
            maxW: remCalc(400),
            mx: 'auto',
            ratio: 1,
        },
        compareTableHeader: {
            justify: 'flex-start',
            background: 'background.base.default',
            align: 'center',
            w: '100%',
            paddingTop: 'small.base',
            paddingBottom: 'small.base',
            paddingX: {base: remCalc(16), lg: remCalc(24)},
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.table',
            marginBottom: {
                base: remCalc(24),
                sm: remCalc(24),
                md: remCalc(32),
                lg: remCalc(32),
            },
            cursor: 'default',
        },
        compareTableHeaderLabel: {
            textAlign: 'left',
            textStyle: 'body-xxlarge',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        compareTableGrid: {gap: remCalc(24), background: 'background.base.default'},
    },
}
